import * as tslib_1 from "tslib";
import { Event } from "./Event";
var TextEvent = (function (_super) {
    tslib_1.__extends(TextEvent, _super);
    function TextEvent(type, bubbles, cancelable, text) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (text === void 0) { text = ""; }
        return _super.call(this, type, bubbles, cancelable) || this;
    }
    Object.defineProperty(TextEvent.prototype, "text", {
        get: function () {
            console.log("text not implemented yet in flash/IOErrorEvent");
            return "";
        },
        set: function (value) {
            console.log("text not implemented yet in flash/IOErrorEvent");
        },
        enumerable: true,
        configurable: true
    });
    TextEvent.prototype.clone = function () {
        console.log("clone not implemented yet in flash/IOErrorEvent");
        return null;
    };
    TextEvent.prototype.toString = function () {
        console.log("toString not implemented yet in flash/IOErrorEvent");
        return "";
    };
    return TextEvent;
}(Event));
export { TextEvent };
TextEvent.LINK = "link";
TextEvent.TEXT_INPUT = "textInput";
TextEvent.NETWORK_ERROR = "networkError";
TextEvent.VERIFY_ERROR = "verifyError";
